<template>
  <div class="d-flex flex-column align-items-start h-100 fs-5 border-left" v-if="charge">
    <span class="fw-bold pl-5 py-3 section-header">Count {{ charge.CountNumber }}: 
      {{ charge.SectionNumber }}</span>
    <div class="d-flex mob-show fs-4">
      <div class="tab px-5 fs-5" @click="mode = 'controls'" :class="mode == 'controls' ? 'tab-active' : 'tab-inactive'">
        Controls
      </div>
      <div class="tab px-5 fs-5" @click="mode = 'info'" :class="mode == 'info' ? 'tab-active' : 'tab-inactive'">
        Info
      </div>
      <div class="tab px-5 fs-5" @click="mode = 'lawText'" :class="mode == 'lawText' ? 'tab-active' : 'tab-inactive'">
        Law Text
      </div>
      <div class="tab px-5 fs-5 border-right" @click="mode = 'collaterals'"
        :class="mode == 'collaterals' ? 'tab-active' : 'tab-inactive'">
        Collaterals
      </div>
    </div>
    <div class="d-flex border-top ">
      <div class="d-flex flex-column w-25 mob-hidden">
        <table class="fw-bold">
          <tbody>
            <tr class="border-top-0 selectable" @click="mode = 'controls'"
              :class="mode == 'controls' ? 'selected' : ''">
              <td class="pl-5">Controls</td>

              <td class="pr-5 ta-r"><i class="fa fa-chevron-right fs-5 "></i></td>
            </tr>
            <tr class="selectable" @click="mode = 'info'" :class="mode == 'info' ? 'selected' : ''">
              <td class="pl-5">Info</td>

              <td class="pr-5 ta-r"><i class="fa fa-chevron-right fs-5 "></i></td>
            </tr>
            <tr class="selectable" @click="mode = 'lawText'" :class="mode == 'lawText' ? 'selected' : ''">
              <td class="pl-5">Authority</td>

              <td class="pr-5 ta-r"><i class="fa fa-chevron-right fs-5 "></i></td>
            </tr>
            <tr class="selectable border-bottom" @click="mode = 'collaterals'"
              :class="mode == 'collaterals' ? 'selected' : ''">
              <td class="pl-5">Collaterals</td>

              <td class="pr-5 ta-r"><i class="fa fa-chevron-right fs-5 "></i></td>
            </tr>
          </tbody>
        </table>
        <!-- <select v-model="mode" class="form-control-lg tab-show">
          <option value="controls">Controls</option>
          <option value="info">Info</option>
          <option value="lawText">Authority</option>
          <option value="collaterals">Collaterals</option>
        </select> -->
      </div>
      <div class="d-flex flex-column col-12 col-lg-9 p-0 border-left" v-if="mode == 'info'">
        <div class="d-flex flex-column mob-hidden">
          <table class="border-0 mb-0">
            <tbody class="border-bottom">
              <tr class="border-0">
                <td class="fw-bold w-25">Offense Date:</td>
                <td class="w-25 ta-r border-right">
                  {{ createMoment(charge.Date)?.format("MM/DD/YYYY") }}
                  <span v-if="charge?.DateRangeEnd != null">- {{ createMoment(charge.DateRangeEnd)?.format("MM/DD/YYYY")
                    }}</span>
                </td>
                <td class="fw-bold w-25">Strike:</td>
                <td class="w-25 ta-r">
                  <button @click="
                    emitPopupText({
                      header: 'Strike',
                      body: enhancedAuthorityText(charge, charges.data, 'strike'),
                    })
                    " class="btn-xl btn btn-primary">
                    <span v-if="charge.IsSerious || charge.IsViolent">Yes</span>
                    <span v-else-if="charge.EnhancedSerious || charge.EnhancedViolent">Yes (Enhanced)</span>
                    <span v-else>No</span>
                  </button>
                </td>
              </tr>
              <tr>
                <td class="fw-bold w-25">Charge Type:</td>
                <td class="w-25 ta-r border-right">
                  <span class="" v-if="charge.CrimeTypeId == 1">Status Enhancement</span>
                  <span class="" v-if="charge.CrimeTypeId == 2">Substitution Enhancement</span>
                  <span class="" v-if="charge.CrimeTypeId == 3">Probation Allegation</span>
                  <span class="ml-4" v-if="charge.CrimeTypeId == 5">Crime</span>
                  <span class="" v-if="charge.CrimeTypeId == 6">Conduct Enhancement</span>
                </td>
                <td class="fw-bold w-25">Violent:</td>
                <td class="w-25 ta-r">
                  <button @click="
                    emitPopupText({
                      header: 'Violent Felony',
                      body: enhancedAuthorityText(charge, charges.data, 'violent'),
                    })
                    " class="btn-xl btn btn-primary">
                    <span v-if="charge.IsViolent">Yes</span>
                    <span v-else-if="charge.EnhancedViolent">Yes (Enhanced)</span>
                    <span v-else>No</span>
                  </button>
                </td>
              </tr>
              <tr>
                <td class="fw-bold w-25">Probation Eligibility:</td>
                <td class="w-25 ta-r border-right">
                  <span class="ml-4">{{
                    [
                      "Eligible",
                      "Ineligible",
                      "Unusual",
                      "Unusual/Sex A",
                      "Sex A",
                      "Sex B",
                    ][charge?.ProbationLimitation] ?? "Eligible"
                  }}</span>
                </td>
                <td class="fw-bold w-25">Serious:</td>
                <td class="w-25 ta-r">
                  <button @click="
                    emitPopupText({
                      header: 'Serious Felony',
                      body: enhancedAuthorityText(charge, charges.data, 'serious'),
                    })
                    " class="btn-xl btn btn-primary">
                    <span v-if="charge.IsSerious">Yes</span>
                    <span v-else-if="charge.EnhancedSerious">Yes (Enhanced)</span>
                    <span v-else>No</span>
                  </button>
                </td>
              </tr>
              <tr>
                <td class="fw-bold w-25">Sentencing Scheme:</td>
                <td class="w-25 ta-r border-right">
                  <p class="m-0" v-if="charge.newExposureObject?.isPrincipal == 0 && 
                    charge.SubordinateSTIRFactor != 3 &&
                    charge?.RunSTIRCalculation == true
                  ">{{ sentencingSchemeLabel(charge) }}</p>
                  <p class="m-0" v-else-if="
                    charge.newExposureObject?.isPrincipal == 0 ||
                    charge.newExposureObject?.isPrincipal == 1
                  ">
                    PC 1170.1(a)
                  </p>
                  <p class="m-0" v-else-if="
                    charge?.newExposureObject?.isPrincipal == 2 
                  ">
                    PC 669
                  </p>
                  
                  <p class="m-0" v-else-if="charge?.newExposureObject?.isPrincipal == 3">
                     {{ charge.SectionNumber }}
                  </p>
                  <p class="m-0" v-else-if="charge?.newExposureObject?.isPrincipal == 4">
                    <span v-if="charge.CrimeSeverityId == 2">PC 18.5</span>
                    <span v-else-if="charge.CrimeSeverityId == 1">PC 19.6</span>
                  </p>
                  <p class="m-0" v-else-if="charge?.newExposureObject?.isPrincipal == 6">
                    {{ sentencingSchemeLabel(charge) }}
                  </p>
                </td>
                <td class="fw-bold w-25">Super Strike:</td>
                <td class="w-25 ta-r">
                  <button @click="
                    emitPopupText({
                      header: 'Super Strike',
                      body: enhancedAuthorityText(charge, charges.data, 'superStrike'),
                    })
                    " class="btn-xl btn btn-primary">
                    <span v-if="charge.IsSuperStrike">Yes</span>
                    <span v-else-if="charge.EnhancedSuperStrike">Yes (Enhanced)</span>
                    <span v-else>No</span>
                  </button>
                </td>
              </tr>

              <tr>
                <td class="fw-bold w-25">PC 1170(h) Eligibility:</td>
                <td class="w-25 ta-r border-right">
                  <button @click="
                    emitPopupText({
                      header: 'PC 1170(h) Eligibility',
                      body: enhancedAuthorityText(charge, charges.data, 'pc1170h'),
                    })
                    " class="btn btn-primary btn-xl">
                    
                    <span>{{ pc1170hDisplay(charge) }}</span>
                  </button>
                </td>
                <td class="fw-bold w-25">Third Strike Trigger:</td>
                <td class="w-25 ta-r">
                  <button @click="
                    emitPopupText({
                      header: 'Third Strike Trigger',
                      body: enhancedAuthorityText(charge, charges.data, 'thirdStrike'),
                    })
                    " class="btn-xl btn btn-primary">
                    <span v-if="charge.IsThirdStrikeTrigger ">Yes</span>
                    <span v-else-if="charge.EnhancedThirdStrikeTrigger">Yes (Enhanced)</span>
                    <span v-else>No</span>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="mob-show w-100">
          <table class="border-0 mb-0 w-100">
            <tbody class="border-bottom">
              <tr class="border-0">
                <td class="fw-bold w-50 px-5">Offense Date:</td>
                <td class="w-50 px-5 ta-r">
                  {{ createMoment(charge.Date)?.format("MM/DD/YYYY") }}
                  <span v-if="charge?.DateRangeEnd != null">- {{ createMoment(charge.DateRangeEnd)?.format("MM/DD/YYYY")
                    }}</span>
                </td>
              </tr>
              <tr>
                <td class="fw-bold w-50 px-5">Charge Type:</td>
                <td class="w-50 px-5 ta-r">
                  <span class="ml-4" v-if="charge.CrimeTypeId == 1">Status Enhancement</span>
                  <span class="ml-4" v-if="charge.CrimeTypeId == 2">Substitution Enhancement</span>
                  <span class="ml-4" v-if="charge.CrimeTypeId == 3">Probation Allegation</span>
                  <span class="ml-4" v-if="charge.CrimeTypeId == 5">Crime</span>
                  <span class="ml-4" v-if="charge.CrimeTypeId == 6">Conduct Enhancement</span>
                </td>
              </tr>
              <tr>
                <td class="fw-bold w-50 px-5">Probation Eligibility:</td>
                <td class="w-50 px-5 ta-r">
                  <span class="ml-4">{{
                    [
                      "Eligible",
                      "Ineligible",
                      "Unusual",
                      "Unusual/Sex A",
                      "Sex A",
                      "Sex B",
                    ][charge?.ProbationLimitation] ?? "Eligible"
                  }}</span>
                </td>
              </tr>
              <tr>
                <td class="fw-bold w-50 px-5">Sentencing Authority:</td>
                <td class="w-50 px-5 ta-r">
                  <p class="m-0" v-if="charge.newExposureObject?.isPrincipal == 0 && 
                    charge.SubordinateSTIRFactor != 3 &&
                    charge?.RunSTIRCalculation == true
                  ">{{ sentencingSchemeLabel(charge) }}</p>
                  <p class="m-0" v-else-if="
                    charge.newExposureObject?.isPrincipal == 0 ||
                    charge.newExposureObject?.isPrincipal == 1
                  ">
                    PC 1170.1(a)
                  </p>
                  <p class="m-0" v-else-if="
                    charge?.newExposureObject?.isPrincipal == 2
                  ">
                    PC 669
                  </p>
                  <p class="m-0" v-else-if="charge?.newExposureObject?.isPrincipal == 3">
                     {{ charge.SectionNumber }}
                  </p>
                  <p class="m-0" v-else-if="charge?.newExposureObject?.isPrincipal == 4">
                    PC 18.5
                  </p>
                  <p class="m-0" v-else-if="charge?.newExposureObject?.isPrincipal == 6">
                    PC 667.6
                  </p>
                </td>
              </tr>
              <tr>
                <td class="fw-bold w-50 px-5">Strike:</td>
                <td class="w-50 px-5 ta-r">
                  <button @click="
                    emitPopupText({
                      header: 'Strike',
                      body: enhancedAuthorityText(charge, charges.data, 'strike'),
                    })
                    " class="btn-xl btn btn-primary">
                    <span v-if="isViolent(charge) || isSerious(charge)">Yes</span>
                    <span v-else>No</span>
                  </button>
                </td>
              </tr>

              <tr>
                <td class="fw-bold w-50 px-5">Violent:</td>
                <td class="w-50 px-5 ta-r">
                  <button @click="
                    emitPopupText({
                      header: 'Violent Felony',
                      body: enhancedAuthorityText(charge, charges.data, 'violent'),
                    })
                    " class="btn-xl btn btn-primary">
                    <span v-if="isViolent(charge)">Yes</span> <span v-else>No</span>
                  </button>
                </td>
              </tr>

              <tr>
                <td class="fw-bold w-50 px-5">Serious:</td>
                <td class="w-50 px-5 ta-r">
                  <button @click="
                    emitPopupText({
                      header: 'Serious Felony',
                      body: enhancedAuthorityText(charge, charges.data, 'serious'),
                    })
                    " class="btn-xl btn btn-primary">
                    <span v-if="isSerious(charge)">Yes</span>
                    <span v-else>No</span>
                  </button>
                </td>
              </tr>

              <tr>
                <td class="fw-bold w-50 px-5">Super Strike:</td>
                <td class="w-50 px-5 ta-r">
                  <button @click="
                    emitPopupText({
                      header: 'Super Strike',
                      body: enhancedAuthorityText(charge, charges.data, 'superStrike'),
                    })
                    " class="btn-xl btn btn-primary">
                    <span v-if="charge.IsSuperStrike">Yes</span>
                    <span v-else>No</span>
                  </button>
                </td>
              </tr>

              <tr>
                <td class="fw-bold w-50 px-5">PC 1170(h) Eligibility:</td>
                <td class="w-50 px-5 ta-r">
                  <button @click="
                    emitPopupText({
                      header: 'PC 1170(h) Eligibility',
                      body: enhancedAuthorityText(charge, charges.data, 'pc1170h'),
                    })
                    " class="btn btn-primary btn-xl">
                    <span>{{ pc1170hDisplay(charge) }}</span>
                  </button>
                </td>
              </tr>
              <tr>
                <td class="fw-bold w-50 px-5">Third Strike Trigger:</td>
                <td class="w-50 px-5 ta-r">
                  <button @click="
                    emitPopupText({
                      header: 'Third Strike Trigger',
                      body: enhancedAuthorityText(charge, charges.data, 'thirdStrike'),
                    })
                    " class="btn-xl btn btn-primary">
                    <span v-if="charge.IsThirdStrikeTrigger">Yes</span>
                    <span v-else>No</span>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- <p class=" mb-1" v-if="getEnhancements?.length > 0">Enhancements</p> -->
      </div>

      <div class="d-flex flex-column col-12 col-lg-9 p-0 border-left" v-if="mode == 'lawText'">
        <div class="d-flex flex-column">
          <table class="border-0 w-100 mob-hidden">
            <tbody class="border-bottom">
              <tr class="border-top-0 ">
                <td class="fw-bold w-25">Statute:</td>
                <td class="w-25 ta-r border-right">
                  <button @click="
                    emitPopupText({
                      header: 'Statute Text',
                      body: charge.DefinitionText,
                    })
                    " class="btn btn-primary btn-xl">
                    View
                  </button>
                </td>
                <!-- </tr>
              <tr class="border-right"> -->
                <td class="fw-bold w-25">Elements:</td>
                <td class="w-25 ta-r">
                  <button @click="
                    emitPopupText({
                      header: 'Elements',
                      body: charge.Elements,
                    })
                    " class="btn btn-primary btn-xl">
                    View
                  </button>
                </td>
              </tr>
              <tr class="">
                <td class="fw-bold w-25">Probation Eligibility:</td>
                <td class="w-25 ta-r border-right">
                  <button @click="emitProbationText(charge)" class="btn btn-primary btn-xl">
                    View
                  </button>
                </td>
                <!-- </tr>

              <tr class="border-right"> -->
                <td class="fw-bold w-25" v-if="charge.PunishmentText?.length > 0">
                  Punishment:
                </td>
                <td class="ta-r w-25" v-if="charge.PunishmentText?.length > 0">
                  <button @click="
                    emitPopupText({
                      header: 'Punishment Text',
                      body: charge.PunishmentText,
                    })
                    " class="btn btn-primary btn-xl">
                    View
                  </button>
                </td>
              </tr>
              <!-- <tr class="border-right"> 
                <td class="fw-bold w-25" v-if="charge.newExposureObject?.ruleWords?.length > 0">
                  Rule Words:
                </td>
                <td class="ta-r w-25" v-if="charge.newExposureObject?.ruleWords?.length > 0">
                  <button
                    @click="
                      emitPopupText({
                        header: 'Rule Words',
                        body: `<p>${charge.newExposureObject?.ruleWords?.join('</p><br/><p>')}</p>`,
                      })
                    "
                    class="btn btn-primary btn-xl"
                  >
                    View
                  </button>
                </td>
              </tr> -->
            </tbody>
          </table>
          <div class="mob-show w-100">
            <table class="w-100">
              <tbody class="border-bottom">
                <tr class="border-top-0">
                  <td class="fw-bold px-5 w-50">Statute:</td>
                  <td class="px-5 w-50 ta-r border-right">
                    <button @click="
                      emitPopupText({
                        header: 'Statute Text',
                        body: charge.DefinitionText,
                      })
                      " class="btn btn-primary btn-xl">
                      View
                    </button>
                  </td>
                </tr>
                <tr class="border-top">
                  <td class="fw-bold px-5 w-50">Elements:</td>
                  <td class="px-5 w-50 ta-r border-right">
                    <button @click="
                      emitPopupText({
                        header: 'Elements',
                        body: charge.Elements,
                      })
                      " class="btn btn-primary btn-xl">
                      View
                    </button>
                  </td>
                </tr>
                <tr class="border-top">
                  <td class="fw-bold px-5 w-50">Punishment Text:</td>
                  <td class="px-5 w-50 ta-r border-right">
                    <button @click="
                      emitPopupText({
                        header: 'Punishment Text',
                        body: charge.PunishmentText,
                      })
                      " class="btn btn-primary btn-xl">
                      View
                    </button>
                  </td>
                </tr>
                <tr class="border-top">
                  <td class="fw-bold px-5 w-50">Probation Eligibility:</td>
                  <td class="px-5 w-50 ta-r border-right">
                    <button @click="emitProbationText(charge)" class="btn btn-primary btn-xl">
                      View
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="d-flex flex-column col-12 col-lg-9 p-0 border-left" v-if="mode == 'collaterals'">
        <!-- <div class="card-header py-2">
          <p class=" mb-1">Collaterals</p>
        </div> -->
        <div class="d-flex flex-column mob-hidden scrollable" style=" overflow: auto">
          <table class="border-0" v-if="charge?.ccArray?.length > 0">
            <tbody class="border-bottom">
              <tr v-for="(cc, index) in ccColumns" :key="cc?.Id" :class="index > 0 ? 'border-top' : 'border-0'">
                <td class="w-50 fw-bold td-with-button" :class="parseUnits(cc[1]) ? 'border-right' : ''">
                  <div class="d-flex w-100 justify-content-between align-items-center">
                    <span>{{ cc[0]?.Name }}</span>

                    <button @click="
                      emitPopupText({
                        header: cc[0]?.Name,
                        body: cc[0]?.LawTextYes || cc[0]?.LawTextNo,
                      })
                      " class="btn btn-xl btn-primary">
                      {{
                        `${cc[0].PenaltyUnits > 0 && cc[0].PenaltyUnits != 5
                          ? cc[0].MinimumPenalty !== cc[0].MaximumPenalty
                            ? `${cc[0].MinimumPenalty} - ${cc[0].MaximumPenalty}`
                            : cc[0].MaximumPenalty
                          : ""
                        } ${parseUnits(cc[0])}`
                      }}
                    </button>
                  </div>

                </td>
                <td class="w-50 fw-bold py-0 td-with-button" v-if="parseUnits(cc[1])">
                  <div class="d-flex w-100 justify-content-between align-items-center">
                    <span>{{ cc[1]?.Name }}</span>

                    <button @click="
                      emitPopupText({
                        header: cc[1]?.Name,
                        body: cc[1]?.LawTextYes || cc[1]?.LawTextNo,
                      })
                      " class="btn btn-xl btn-primary">
                      {{
                        `${cc[1].PenaltyUnits > 0 && cc[1].PenaltyUnits != 5
                          ? cc[1].MinimumPenalty !== cc[1].MaximumPenalty
                            ? `${cc[1].MinimumPenalty} - ${cc[1].MaximumPenalty}`
                            : cc[1].MaximumPenalty
                          : ""
                        } ${parseUnits(cc[1])}`
                      }}
                    </button>
                  </div>

                </td>
                <!-- <td  class="w-50 fw-bold" >{{ cc[1]?.Name }}</td>
                <td style="width: 15%" class="ta-r" v-if="parseUnits(cc[1])">
                  <button
                    @click="
                      emitPopupText({
                        header: cc[1]?.Name,
                        body: cc[1]?.LawTextYes || cc[1]?.LawTextNo,
                      })
                    "
                    class="btn btn-xl btn-primary"
                  >
                    {{
                      `${
                        cc[1]?.PenaltyUnits > 0 && cc[1]?.PenaltyUnits != 5
                          ? cc[1]?.MinimumPenalty !== cc[1]?.MaximumPenalty
                            ? `${cc[1]?.MinimumPenalty} - ${cc[1]?.MaximumPenalty}`
                            : cc[1]?.MaximumPenalty
                          : ""
                      } ${parseUnits(cc[1])}`
                    }}
                  </button>
                </td> -->
              </tr>
            </tbody>
          </table>
        </div>
        <div class="mob-show">
          <table>
            <tbody class="border-bottom">
              <tr v-for="(cc, index) in charge?.ccArray?.map(
                (cc) => cc.CollateralConsequence
              )" :key="cc?.Id" :class="index > 0 ? 'border-top' : 'border-0'">
                <td class="px-5 fw-bold">{{ cc?.Name }}</td>
                <td class="px-5 ta-r">
                  <button @click="
                    emitPopupText({
                      header: cc?.Name,
                      body: cc?.LawTextYes || cc?.LawTextNo,
                    })
                    " class="btn btn-xl btn-primary">
                    {{
                      `${cc.PenaltyUnits > 0 && cc.PenaltyUnits != 5
                        ? cc.MinimumPenalty !== cc.MaximumPenalty
                          ? `${cc.MinimumPenalty} - ${cc.MaximumPenalty}`
                          : cc.MaximumPenalty
                        : ""
                      } ${parseUnits(cc)}`
                    }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="d-flex flex-column col-12 col-lg-9 p-0 border-left" v-if="mode == 'controls'">
        <!-- <div class="card-header py-2">
          <p class="fw-bold mb-1">Charge Controls</p>
        </div> -->
        <div class="d-flex flex-column">
          <table class="border-0 mob-hidden">
            <tbody class="border-bottom">
              <tr class="border-0">
                <td class="fw-bold w-25"><label for="chargeStatus">Status: </label></td>
                <td class="w-25 ta-r border-right">
                  <select name="chargeStatus" id="chargeStatus" class="form-control fs-5"
                    @change="chargeStatusChange($event, charge)" v-model="charge.ChargeStatus">
                    <option value="0" :selected="charge.ChargeStatus == '0'">
                      Convicted
                    </option>
                    <option value="1" :selected="charge.ChargeStatus == '1'">
                      Acquitted
                    </option>
                    <option value="2" :selected="charge.ChargeStatus == '2'">
                      Dismissed
                    </option>
                    <option value="3" :selected="charge.ChargeStatus == '3'">
                      Stayed 654
                    </option>
                    <option v-if="charge.ChargeStatus == '4'" value="4" :selected="charge.ChargeStatus == '4'">
                      Stayed
                    </option>
                    <option v-else value="6" :selected="charge.ChargeStatus == '6'">
                      Stayed
                    </option>
                  </select>
                </td>
                <td class="fw-bold w-25">
                  <label for="strikes"> Prior Strikes: </label>
                </td>
                <td class="ta-r">
                  <select name="strikes" id="strikes" class="form-control fs-5" @change="setStrikes"
                    v-model="charge.NumberOfStrikes">
                    <option :value="'0'">0</option>
                    <option :value="'1'">1</option>
                    <option :value="'2+'">2+</option>
                    <option :value="'2+!'">2+ Super Strike</option>
                    <!-- <option value="2+!" >
                      2+ (Super Strike)
                    </option> -->
                  </select>
                </td>
              </tr>
              <tr>
                <td class="fw-bold w-25">Concurrency:</td>
                <td class="w-25 ta-r border-right">
                  <select v-if="isConcurrencyLocked(charge)" class="form-control" disabled>
                    <option>Consecutive</option>
                  </select>
                  <select v-else v-model="charge.Concurrency" class="form-control" @change="toggleConcurrency">
                    <option :value="0">Consecutive</option>
                    <option :value="1">Concurrent</option>
                  </select>
                  <!-- <button
                    class="btn btn-xl mr-3"
                    @click="toggleConcurrency"
                    v-if="!charge.IsMandatoryConsecutive"
                    :class="charge.Concurrency ? 'btn-primary' : 'btn-primary-outline'"
                  >
                    CC
                  </button>
                  <button
                    class="btn btn-xl"
                    @click="toggleConcurrency"
                    :class="!charge.Concurrency ? 'btn-primary' : 'btn-primary-outline'"
                  >
                    CS
                  </button> -->
                </td>
                <!-- <td class="fw-bold w-25">
                  <label for="strikes"> Super Strike Prior: </label>
                </td>
                <td class="ta-r">
                  <button
                    @click="
                      charge.NumberOfStrikes = '2+!';
                      setStrikes();
                    "
                    class="btn btn-xl"
                    :class="
                      charge.NumberOfStrikes == '2+'
                        ? 'btn-primary-outline'
                        : 'btn-primary'
                    "
                  >
                    Yes
                  </button>
                  <button
                    @click="
                      charge.NumberOfStrikes = '2+';
                      setStrikes();
                    "
                    class="btn btn-xl"
                    :class="
                      charge.NumberOfStrikes == '2+'
                        ? 'btn-primary'
                        : 'btn-primary-outline'
                    "
                  >
                    No
                  </button>
                </td> -->
                <td class="fw-bold w-25">
                  <label fow-25 r="wobble">Wobble:</label>
                </td>
                <td class="ta-r ">
                  <select name="wobble" id="wobbled" class="form-control" v-if="charge.WobbleDirection !== 0"
                    @change="wobble(charge)">
                    <option v-if="
                      charge.CrimeSeverityName == 'Felony' ||
                      (charge.CrimeSeverityName == 'Misdemeanor' &&
                        charge.WobbleDirection == 1)
                    " value="3" :selected="charge.CrimeSeverityName == 'Felony'">
                      Felony
                    </option>
                    <option value="2" :selected="charge.CrimeSeverityName == 'Misdemeanor'">
                      Misd
                    </option>
                    <option value="1" v-if="
                      charge.CrimeSeverityName == 'Infraction' ||
                      (charge.CrimeSeverityName == 'Misdemeanor' &&
                        charge.WobbleDirection == 2)
                    " :selected="charge.CrimeSeverityName == 'Infraction'">
                      Inf
                    </option>
                  </select>
                  <p class="m-0" v-else>Not a Wobbler</p>
                </td>
              </tr>

              <tr>

                <td class="fw-bold w-25">Sentencing Scheme:</td>
                <td class="w-25 ta-r border-right">
                  <span v-if="charge?.newExposureObject?.isPrincipal == 4">
                    Selected Length
                  </span>
                  <span v-else-if="charge?.newExposureObject?.isPrincipal == 3">
                    Full Term
                  </span>
                  <span v-else-if="charge?.newExposureObject?.isPrincipal == 2">
                    Indeterminate
                  </span>
                  <span
                    v-else-if="charge?.newExposureObject?.isPrincipal == 1 && (charge.SubordinateSTIRFactor == 3 || 
                      (charge.CrimeSeverityId == 2 && isMisdemeanorSubstitutedToAFelony(charge)))">
                    Full Selected Term
                  </span>
                  <span
                    v-else-if="charge.SubordinateSTIRFactor !== 3 && charge.IncludeInPrincipalCalculation !== 2 && isSingleChargeCase(charges.data)">
                    PC 1170.1(a)
                  </span>
                  <select class="form-control"
                    v-else-if="charge.SubordinateSTIRFactor !== 3 && charge.IncludeInPrincipalCalculation !== 2
                    " 
                    v-model="charge.RunSTIRCalculation"
                    @change="toggleRunStirCalculation(charge)"
                  >
                    <option :value="true">{{ sentencingSchemeLabel(charge) }}</option>
                    <option :value="false">PC 1170.1(a)</option>
                  </select>
                  <span  v-else-if="charge.SubordinateSTIRFactor !== 3 && charge.IncludeInPrincipalCalculation == 2" >
                    {{ sentencingSchemeLabel(charge) }}
                  </span>
                  <span v-else>
                    <span v-if="(charge.newExposureObject?.isPrincipal == 0 && (charge.SubordinateSTIRFactor == 3 && charge.CrimeTypeId == 5) || (
                      charge.CrimeTypeId == 6 && (
                        charge.parentCharge?.EnhancementSTIRFactor == 3 ||
                        charge.parentCharge?.RunSTIRCalculation == false
                      )
                    ))">
                      1/3 </span>
                    <span v-else>Full </span>
                    <span v-if="charge.CrimeTypeId == 5">Middle</span>
                    <span v-if="charge.CrimeTypeId == 6">Selected</span>
                    Term
                  </span>

                </td>
                <!-- <td class="fw-bold w-25">
                  Probation Granted
                </td>
                <td class="w-25 ta-r ">
                  <button class="btn" v-if="probationEligibility?.Eligible" @click="toggleProbationGrant" :class="charge.ProbationGranted ? 'btn-primary-outline' : 'btn-primary'">
                    {{ charge.ProbationGranted ? 'Revoke' : 'Grant' }}
                  </button>
                  <span v-else>Ineligible</span>
                </td> -->
                <td class="fw-bold">
                  Principal Term:
                </td>
                <td class="ta-r ">
                  <select class="mt-0 form-control fs-5 border" v-model="charge.IsPrincipal"
                  :disabled="!isPrincipalTermChangeable(charge, principalTies)"
                  @change="selectPrincipal">
                    <option class="p-2" :value="true">Preferred</option>
                    <option class="p-2" :value="false">Unspecified</option>
                  </select>
                </td>
              </tr>
              <tr v-if="charge.ChargedPer">

                <td v-if="charge.ChargedPer" class="fw-bold">Charge Details:</td>
                <td v-if="charge.ChargedPer" class="ta-r">
                  <button class="btn btn-xl btn-primary" @click="emitFactorSelect">
                    Select
                  </button>
                </td>
              </tr>
              

            </tbody>
          </table>
          <div class="mob-show w-100">
            <table class="w-100">
              <tbody class="border-bottom">
                <tr class="border-0">
                  <td class="fw-bold w-50 px-5">
                    <label for="chargeStatus">Status: </label>
                  </td>
                  <td class="w-50 px-5 ta-r border-right">
                    <select name="chargeStatus" id="chargeStatus" class="form-control fs-5"
                      @change="chargeStatusChange($event, charge)" v-model="charge.ChargeStatus">
                      <option value="0" :selected="charge.ChargeStatus == '0'">
                        Convicted
                      </option>
                      <option value="1" :selected="charge.ChargeStatus == '1'">
                        Acquitted
                      </option>
                      <option value="2" :selected="charge.ChargeStatus == '2'">
                        Dismissed
                      </option>
                      <option value="3" :selected="charge.ChargeStatus == '3'">
                        Stayed 654
                      </option>
                      <option v-if="charge.ChargeStatus == '4'" value="4" :selected="charge.ChargeStatus == '4'">
                        Stayed
                      </option>
                      <option v-else value="6" :selected="charge.ChargeStatus == '6'">
                        Stayed
                      </option>
                    </select>
                  </td>
                </tr>
                <tr>
                  <td class="fw-bold w-50 px-5">
                    <label for="strikes"> Prior Strikes: </label>
                  </td>
                  <td class="w-50 px-5 ta-r">
                    <select name="strikes" id="strikes" class="form-control fs-5" @change="setStrikes"
                      v-model="charge.NumberOfStrikes">
                      <option value="0">0</option>
                      <option value="1">1</option>
                      <option value="2+">
                        2+
                      </option>
                      <option value="2+!">2+ Super Strike</option>
                      <!-- <option value="2+!" >
                        2+ (Super Strike)
                      </option> -->
                    </select>
                  </td>
                </tr>
                <tr>
                  <td class="fw-bold w-50 px-5">Concurrency:</td>
                  <td class="w-50 px-5 ta-r border-right">
                    <select v-if="isConcurrencyLocked(charge)" class="form-control" disabled>
                      <option>Consecutive</option>
                    </select>
                    <select v-else v-model="charge.Concurrency" class="form-control" @change="toggleConcurrency">
                      <option :value="0">Consecutive</option>
                      <option :value="1">Concurrent</option>
                    </select>
                    <!-- <button
                      class="btn btn-xl mr-3"
                      @click="toggleConcurrency"
                      v-if="!charge.IsMandatoryConsecutive"
                      :class="charge.Concurrency ? 'btn-primary' : 'btn-primary-outline'"
                    >
                      CC
                    </button>
                    <button
                      class="btn btn-xl"
                      @click="toggleConcurrency"
                      :class="!charge.Concurrency ? 'btn-primary' : 'btn-primary-outline'"
                    >
                      CS
                    </button> -->
                  </td>
                </tr>
                <!-- <tr>
                  <td class="fw-bold w-50 px-5">
                    <label for="strikes"> Super Strike Prior: </label>
                  </td>
                  <td class="w-50 px-5 ta-r">
                    <button
                      @click="
                        charge.NumberOfStrikes = '2+!';
                        setStrikes();
                      "
                      class="btn btn-xl"
                      :class="
                        charge.NumberOfStrikes == '2+'
                          ? 'btn-primary-outline'
                          : 'btn-primary'
                      "
                    >
                      Yes
                    </button>
                    <button
                      @click="
                        charge.NumberOfStrikes = '2+';
                        setStrikes();
                      "
                      class="btn btn-xl"
                      :class="
                        charge.NumberOfStrikes == '2+'
                          ? 'btn-primary'
                          : 'btn-primary-outline'
                      "
                    >
                      No
                    </button>
                  </td>
                </tr> -->

                <tr>
                  <td class="fw-bold w-50 px-5">
                    <label for="wobble">Wobble:</label>
                  </td>
                  <td class="w-50 px-5 ta-r ">
                    <select name="wobble" id="wobbled" class="form-control" v-if="charge.WobbleDirection !== 0"
                      @change="wobble(charge)">
                      <option v-if="
                        charge.CrimeSeverityName == 'Felony' ||
                        (charge.CrimeSeverityName == 'Misdemeanor' &&
                          charge.WobbleDirection == 1)
                      " value="3" :selected="charge.CrimeSeverityName == 'Felony'">
                        Felony
                      </option>
                      <option value="2" :selected="charge.CrimeSeverityName == 'Misdemeanor'">
                        Misd
                      </option>
                      <option value="1" v-if="
                        charge.CrimeSeverityName == 'Infraction' ||
                        (charge.CrimeSeverityName == 'Misdemeanor' &&
                          charge.WobbleDirection == 2)
                      " :selected="charge.CrimeSeverityName == 'Infraction'">
                        Inf
                      </option>
                    </select>
                    <p class="m-0" v-else>Not a Wobbler</p>
                  </td>
                </tr>
                <tr>
                  <td class="fw-bold w-50 px-5">Sentencing Scheme:</td>
                  <td class="w-50 px-5 ta-r">
                    <span v-if="charge?.newExposureObject?.isPrincipal == 4">
                    Selected Length
                  </span>
                  <span v-else-if="charge?.newExposureObject?.isPrincipal == 3">
                    Full Term
                  </span>
                  <span v-else-if="charge?.newExposureObject?.isPrincipal == 2">
                    Indeterminate
                  </span>
                  <span v-else-if="(charge?.newExposureObject?.isPrincipal == 1 && (charge.SubordinateSTIRFactor == 3|| 
                      (charge.CrimeSeverityId == 2 && isMisdemeanorSubstitutedToAFelony(charge))))">
                    Full Selected Term
                  </span>
                  <span
                    v-else-if="charge.SubordinateSTIRFactor !== 3 && charge.IncludeInPrincipalCalculation !== 2 && isSingleChargeCase(charges.data)">
                    PC 1170.1(a)
                  </span>
                  <select class="form-control"
                    v-else-if="charge.SubordinateSTIRFactor !== 3 && charge.IncludeInPrincipalCalculation !== 2
                    " 
                    v-model="charge.RunSTIRCalculation"
                    @change="toggleRunStirCalculation(charge)"
                  >
                    <option :value="true">{{ sentencingSchemeLabel(charge) }}</option>
                    <option :value="false">PC 1170.1(a)</option>
                  </select>
                  <span  v-else-if="charge.SubordinateSTIRFactor !== 3 && charge.IncludeInPrincipalCalculation !== 2" >
                    {{ sentencingSchemeLabel(charge) }}
                  </span>
                  <span v-else>
                    <span v-if="charge.newExposureObject?.isPrincipal == 0 && ((charge.SubordinateSTIRFactor == 3 && charge.CrimeTypeId == 5) || (
                      charge.CrimeTypeId == 6 && (
                        charge.parentCharge?.EnhancementSTIRFactor == 3 || 
                        charge.parentCharge?.RunSTIRCalculation == false
                      )
                    ))">
                    1/3 </span>
                    <span v-else>Full </span>
                    <span v-if="charge.CrimeTypeId == 5">Middle</span>
                    <span v-if="charge.CrimeTypeId == 6">Selected</span>
                     Term
                  </span>
                  </td>
                </tr>
                <tr>
                  <td class="fw-bold w-50 px-5">
                    Principal Term:
                  </td>
                  <td class="ta-r border-right px-5 w-50">
                    <select class="mt-0 form-control fs-5 border" v-model="charge.IsPrincipal"
                      :disabled="!isPrincipalTermChangeable(charge, principalTies)"
                      @change="selectPrincipal">
                      <option class="p-2" :value="true">Principal</option>
                      <option class="p-2" :value="false">Subordinate</option>
                    </select>
                  </td>
                </tr>
                <tr v-if="charge.ChargedPer">
                  <td class="w-50 px-5 fw-bold">
                    Charge Details:
                  </td>
                  <td class="w-50 px-5 ta-r">
                    <button class="btn btn-xl btn-primary" @click="emitFactorSelect">
                      Select
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import SC from "../../components/utils/sharedComponent.vue";
import { handleError } from "../../helpers";
import { isPrincipalTermChangeable, isConcurrencyLocked, sentencingSchemeLabel, isSingleChargeCase, pc1170hDisplay, enhancedAuthorityText } from "../../chargeControlHelpers";
export default {
  name: "CDBWorkspace",
  props: ["charge", "charges", "principalTies", "probationEligibility"],
  data() {
    return {
      // Your data properties here
      mode: "controls",
      app_token: null,
      chg: null,
      NumberOfStrikes: "0",
    };
  },
  components: {
    SC,
  },
  watch: {
    
  },
  computed: {
    // Your computed properties here
    // getEnhancements(){
    //     return this.charges.filter(charge => charge.Id != this.charge.Id && charge.CountNumber == this.charge.CountNumber)
    // }
    ccColumns() {
      let columnArr = [];
      // console.log(this.charge?.ccArray);
      this.charge?.ccArray
        ?.filter((cc) => cc.CollateralConsequence?.Id)
        ?.forEach((collat, i) => {
          if (i % 2 == 0) {
            columnArr.push([]);
          }
          columnArr[columnArr.length - 1].push(collat.CollateralConsequence);
        });
      // console.log(columnArr);
      return columnArr;
    },
    showSchemeOptions() {
      let good = false;
      if (this.charge?.SubordinateSTIRFactor != 3 && this.charge.CrimeSeverityId == 3 && !this.isIndeterminate(this.charge)) {
        good = true;
      }
      return good;
    },
  },
  methods: {
    isPrincipalTermChangeable, // imported: is the Principal Term dropdown changeable (tied for greatest term)?
    isConcurrencyLocked, // imported: is Concurrency forced to Consecutive (mandatory or determinate principal)?
    sentencingSchemeLabel, // imported: 667.6(c) / 667.6(c) or (d) label based on concurrency
    isSingleChargeCase, // imported: single-charge case defaults to PC 1170.1(a)
    pc1170hDisplay, // imported: PC 1170(h) label (serious/violent -> No / No (Enhanced), else stored value)
    enhancedAuthorityText, // imported: popup text from the overriding enhancement when a value is enhanced
    isViolent(charge) {
      return SC.isViolent(charge);
    },
    isSerious(charge) {
      return SC.isSerious(charge);
    },
    isIndeterminate(chg) {
      return SC.isIndeterminate(chg);
    },
    isMisdemeanorSubstitutedToAFelony(chg) {
      return SC.isMisdemeanorSubstitutedToAFelony(chg, this.charges.data);
      // return false
    },
    emitProbationText(chg) {
      let popupText = chg.ProbationLimitationLawText;
      if (chg.ProbationLimitation === 5) {
        popupText = `(a) Notwithstanding Section 1203 or any other law, probation shall not be granted to, nor shall the execution or imposition of sentence be suspended for, nor shall a finding bringing the defendant within the provisions of this section be stricken pursuant to Section 1385 for, any of the following persons:

        <br/><br/>(1) A person who is convicted of violating Section 288 or 288.5 when the act is committed by the use of force, violence, duress, menace, or fear of immediate and unlawful bodily injury on the victim or another person.

        <br/><br/>(2) A person who caused bodily injury on the child victim in committing a violation of Section 288 or 288.5.

        <br/><br/>(3) A person who is convicted of a violation of Section 288 or 288.5 and who was a stranger to the child victim or befriended the child victim for the purpose of committing an act in violation of Section 288 or 288.5, unless the defendant honestly and reasonably believed the victim was 14 years of age or older.

        <br/><br/>(4) A person who used a weapon during the commission of a violation of Section 288 or 288.5.

        <br/><br/>(5) A person who is convicted of committing a violation of Section 288 or 288.5 and who has been previously convicted of a violation of Section 261, 264.1, 266, 266c, 267, 285, 286, 287, 288, 288.5, or 289, or former Section 262 or 288a, or of assaulting another person with intent to commit a crime specified in this paragraph in violation of Section 220, or who has been previously convicted in another state of an offense which, if committed or attempted in this state, would constitute an offense enumerated in this paragraph.

        <br/><br/>(6) A person who violated Section 288 or 288.5 while kidnapping the child victim in violation of Section 207, 209, or 209.5.

        <br/><br/>(7) A person who is convicted of committing a violation of Section 288 or 288.5 against more than one victim.

        <br/><br/>(8) A person who, in violating Section 288 or 288.5, has substantial sexual conduct with a victim who is under 14 years of age.

        <br/><br/>(9) A person who, in violating Section 288 or 288.5, used obscene matter, as defined in Section 311, or matter, as defined in Section 311, depicting sexual conduct, as defined in Section 311.3.

        <br/><br/>(b) “Substantial sexual conduct” means penetration of the vagina or rectum of either the victim or the offender by the penis of the other or by any foreign object, oral copulation, or masturbation of either the victim or the offender.

        <br/><br/>(c) (1) Except for a violation of subdivision (b) of Section 288, this section shall only apply if the existence of any fact required in subdivision (a) is alleged in the accusatory pleading and is either admitted by the defendant in open court, or found to be true by the trier of fact.

        <br/><br/>(2) For the existence of any fact under paragraph (7) of subdivision (a), the allegation must be made pursuant to this section.

        <br/><br/>(d) (1) If a person is convicted of a violation of Section 288 or 288.5, and the factors listed in subdivision (a) are not pled or proven, probation may be granted only if the following terms and conditions are met:

        <br/><br/>(A) If the defendant is a member of the victim’s household, the court finds that probation is in the best interest of the child victim.

        <br/><br/>(B) The court finds that rehabilitation of the defendant is feasible and that the defendant is amenable to undergoing treatment, and the defendant is placed in a recognized treatment program designed to deal with child molestation immediately after the grant of probation or the suspension of execution or imposition of sentence.

        <br/><br/>(C) If the defendant is a member of the victim’s household, probation shall not be granted unless the defendant is removed from the household of the victim until the court determines that the best interests of the victim would be served by the defendant’s return. While removed from the household, the court shall prohibit contact by the defendant with the victim, with the exception that the court may permit supervised contact, upon the request of the director of the court-ordered supervised treatment program, and with the agreement of the victim and the victim’s parent or legal guardian, other than the defendant.

        <br/><br/>(D) If the defendant is not a member of the victim’s household, the court shall prohibit the defendant from being placed or residing within one-half mile of the child victim’s residence for the duration of the probation term unless the court, on the record, states its reasons for finding that this residency restriction would not serve the best interests of the victim.

        <br/><br/>(E) The court finds that there is no threat of physical harm to the victim if probation is granted.

        <br/><br/>(2) The court shall state its reasons on the record for whatever sentence it imposes on the defendant.

        <br/><br/>(3) The court shall order the psychiatrist or psychologist who is appointed pursuant to Section 288.1 to include a consideration of the factors specified in subparagraphs (A), (B), and (C) of paragraph (1) in making the report to the court.

        <br/><br/>(4) The court shall order the defendant to comply with all probation requirements, including the requirements to attend counseling, keep all program appointments, and pay program fees based upon ability to pay.

        <br/><br/>(5) A victim shall not be compelled to participate in a program or counseling, and a program may not condition a defendant’s enrollment on participation by the victim.

        <br/><br/>(e) As used in subdivision (d), the following definitions apply:

        <br/><br/>(1) “Contact with the victim” includes all physical contact, being in the presence of the victim, communicating by any means, including by a third party acting on behalf of the defendant, or sending any gifts.

        <br/><br/>(2) “Recognized treatment program” means a program that consists of the following components:

        <br/><br/>(A) Substantial expertise in the treatment of child sexual abuse.

        <br/><br/>(B) A treatment regimen designed to specifically address the offense.

        <br/><br/>(C) The ability to serve indigent clients.

        <br/><br/>(D) Adequate reporting requirements to ensure that all persons who, after being ordered to attend and complete a program, may be identified for either failure to enroll in, or failure to successfully complete, the program, or for the successful completion of the program as ordered. The program shall notify the court and the probation department, in writing, within the period of time and in the manner specified by the court of any person who fails to complete the program. Notification shall be given if the program determines that the defendant is performing unsatisfactorily or if the defendant is not benefiting from the education, treatment, or counseling.
        <br/><br/>[PC § 1203.066]
        <br /><br /><br />(a) Notwithstanding any other law, before probation may be granted to any person convicted of a felony specified in Section 261, 264.1, 286, 287, 288, 288.5, or 289, or former Section 262 or 288a, who is eligible for probation, the court shall do all of the following:

        <br /><br />(1) Order the defendant evaluated pursuant to Section 1203.03, or similar evaluation by the county probation department.

        <br /><br />(2) Conduct a hearing at the time of sentencing to determine if probation of the defendant would pose a threat to the victim. The victim shall be notified of the hearing by the prosecuting attorney and given an opportunity to address the court.

        <br /><br />(3) Order any psychiatrist or psychologist appointed pursuant to Section 288.1 to include a consideration of the threat to the victim and the defendant’s potential for positive response to treatment in making the report to the court. This section does not require the court to order an examination of the victim.

        <br /><br />(b) The terms of probation for persons placed on formal probation for an offense that requires registration pursuant to Sections 290 to 290.023, inclusive, shall include all of the following:

        <br /><br />(1) A person placed on formal probation prior to July 1, 2012, shall participate in an approved sex offender management program, following the standards developed pursuant to Section 9003, for a period of not less than one year or the remaining term of probation if it is less than one year. The length of the period in the program is to be determined by the certified sex offender management professional in consultation with the probation officer and as approved by the court. Participation in this program applies to every person described without regard to when the person’s crime or crimes were committed.

        <br /><br />(2) A person placed on formal probation on or after July 1, 2012, shall successfully complete a sex offender management program, following the standards developed pursuant to Section 9003, as a condition of release from probation. The length of the period in the program shall be not less than one year, up to the entire period of probation, as determined by the certified sex offender management professional in consultation with the probation officer and as approved by the court. Participation in this program applies to each person without regard to when the person’s crime or crimes were committed.

        <br /><br />(3) Waiver of any privilege against self-incrimination and participation in polygraph examinations, which shall be part of the sex offender management program.

        <br /><br />(4) Waiver of any psychotherapist-patient privilege to enable communication between the sex offender management professional and supervising probation officer, pursuant to Section 290.09.

        <br /><br />(c) A defendant ordered to be placed in an approved sex offender management program pursuant to subdivision (b) shall be responsible for paying the expense of participation in the program as determined by the court. The court shall take into consideration the ability of the defendant to pay, and a defendant shall not be denied probation because of their inability to pay.
        
        <br/><br/>[PC § 1203.067]
        `;
      } else if (chg.ProbationLimitation == 0) {
        popupText = "This crime is not statutorily ineligibile for probation.";
      }
      this.$emit("displayModalPopup", {
        header: "Probation Eligibility",
        body: popupText,
      });
    },
    // Your methods here
    createMoment(date) {
      if (date == null) {
        return null;
      }
      return moment(date);
    },
    emitCalc() {
      this.$emit("calc");
    },
    emitFactorSelect() {
      this.$emit("factorSelect");
    },

    parseUnits(cc) {
      if (!cc) return null;
      if (cc.PenaltyUnits == 0) {
        return "Yes";
      } else if (cc.PenaltyUnits == 1) {
        return `  `;
      } else if (cc.PenaltyUnits == 2) {
        return "d";
      } else if (cc.PenaltyUnits == 3) {
        return "m";
      } else if (cc.PenaltyUnits == 4) {
        return "y";
      } else if (cc.PenaltyUnits == 5) {
        return "Life";
      }
      return null;
    },
    selectPrincipal() {
      this.$nextTick(() => {
        this.postChargeField(this.charge.Id, "IsPrincipal", this.charge.IsPrincipal);
        if (this.charge.IsPrincipal == true) {

          this.$emit("selectPrincipal", this.charge.Id);
        }
      })
    },
    chargeStatusChange($event, chg) {
      const val = parseInt($event.target.value, 10);
      chg.ChargeStatus = val;

      this.postChargeField(chg.Id, "ChargeStatus", val);

      this.$emit("calc");
    },
    setStrikes() {
      SC.postChargeField(
        this.app_token,
        this.charge.Id,
        "NumberOfStrikes",
        this.charge.NumberOfStrikes
      );
      this.$emit("calc");
    },
    toggleConcurrency() {
      // console.log(bool);
      // if (!this.charge.IsMandatoryConsecutive) {
      //   this.charge.Concurrency = !this.charge.Concurrency;
      // }
      this.$nextTick(() => {
        this.$emit("calc");
        SC.postChargeFieldValue(
          this.charge.Id,
          "Concurrency",
          this.charge.Concurrency,
          localStorage.getItem("user_token"),
          this.charge.CaseId
        ).then((result) => { });
      });
      // console.log(chg);
    },
    toggleProbationGrant() {
      this.charge.ProbationGranted = !this.charge.ProbationGranted;
      SC.postChargeFieldValue(
        this.charge?.Id,
        "ProbationGranted",
        this.charge?.ProbationGranted,
        localStorage.getItem("user_token"),
        this.caseId
      ).then((result) => {
        this.$emit("calc");
      });
    },
    async toggleRunStirCalculation(chg) {

      this.postChargeField(chg.Id, "RunSTIRCalculation", chg.RunSTIRCalculation);
      this.$nextTick(() => {
        this.$emit('calc')
      })
      // this.$emit('calc')
    },
    async postChargeField(Id, field, e) {
      let this_app_token = localStorage.getItem("user_token");

      let value = e.target?.value || e;
      // console.log("Id>>>", Id);

      SC.postChargeField(this_app_token, Id, field, value);
      this.$emit("calc");
    },
    emitPopupText(obj) {
      this.$emit("displayModalPopup", obj);
    },
    async wobble(charge) {
      let wobble = charge.WobbleDirection;
      const foundWobbleBuddy = await axios.post(
        process.env.VUE_APP_ENDPOINT + "/api/crimes/wobble",
        {
          CrimeId: charge.CrimeId,
          wobbleDirection: wobble,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("user_token")}`,
          },
        }
      );

      if (foundWobbleBuddy?.data) {
        let tempCrime = {};
        if (charge.WobbleDirection == 1) {
          tempCrime.Id = foundWobbleBuddy?.data?.WobbleDownCrimeId;
        } else {
          tempCrime.Id = foundWobbleBuddy?.data?.WobbleUpCrimeId;
        }

        const replacedCharge = await SC.replaceCharge(
          charge,
          tempCrime,
          localStorage.getItem("user_token")
        );

        this.$emit("refreshCharges");
      }
    },

  },
  mounted() {
    // console.log(this.charge);
    this.app_token = localStorage.getItem("user_token");
    this.chg = this.charge;
    const numberOfStrikes = this.charge?.NumberOfStrikes;
    this.NumberOfStrikes = numberOfStrikes;
  },
};
</script>

<style scoped>
.workspace-tr {
  width: 100%;
  min-height: 400px !important;
  height: 400px !important;
}

.workspace {
  width: 100%;
  min-height: 100%;
  font-weight: normal !important;
  font-weight: bold;
}

.ta-r {
  text-align: right;
}

table {
  width: 100%;
}

label {
  margin: 0;
}

/* Your component styles here */
</style>
